/* Swiss Poster Design - product page behaviour.

   Handles Gelato products with one option (Size) or three
   (Size x Product x Style). The UI is generated from the product's options;
   this resolves the variant by matching every selected value, then updates
   price, SKU, availability and the gallery.

   Ports SizePicker.jsx (the size listbox) and OptionSwatch.jsx (everything
   else), plus prev/next navigation over the visible gallery. */
(function () {
  function init(root) {
    var dataEl = root.querySelector('[data-spd-variants]');
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!variants.length) return;

    var input = root.querySelector('[data-spd-variant-input]');
    var priceEl = root.querySelector('[data-spd-price]');
    var compareEl = root.querySelector('[data-spd-compare]');
    var skuEl = root.querySelector('[data-spd-sku]');
    var submit = root.querySelector('[data-spd-submit]');
    var optionGroups = [].slice.call(root.querySelectorAll('[data-spd-option]'));
    var sizeGroup = root.querySelector('[data-option-kind="size"]');
    var sizeIndex = sizeGroup ? (parseInt(sizeGroup.dataset.optionPosition, 10) || 1) - 1 : 0;

    // ---- selection state, seeded from the variant the page rendered with ----
    var startId = input ? String(input.value) : String(variants[0].id);
    var start = variants.filter(function (v) { return String(v.id) === startId; })[0] || variants[0];
    var selected = start.options.slice();

    function findVariant(values) {
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === values[i]; });
      })[0];
    }

    function paint(variant) {
      selected = variant.options.slice();
      if (input) input.value = variant.id;
      if (priceEl) priceEl.textContent = variant.priceFormatted;
      if (compareEl) compareEl.hidden = true;
      if (skuEl && variant.sku) skuEl.textContent = variant.sku;
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
      }

      optionGroups.forEach(function (group) {
        var isSize = group.dataset.optionKind === 'size';
        var triggerLabel = group.querySelector('[data-spd-trigger-label]');
        var triggerNote = group.querySelector('[data-spd-trigger-note]');
        var triggerPrice = group.querySelector('[data-spd-trigger-price]');
        var triggerChip = group.querySelector('[data-spd-trigger-chip]');

        group.querySelectorAll('[data-spd-opt]').forEach(function (opt) {
          var candidate = selected.slice();
          var isSel;

          if (isSize) {
            candidate[sizeIndex] = opt.dataset.value;
            isSel = selected[sizeIndex] === opt.dataset.value;
          } else {
            var values = (opt.dataset.combo || '').split('~~');
            var vi = 0;
            isSel = true;
            for (var i = 0; i < candidate.length; i++) {
              if (i !== sizeIndex) {
                if (selected[i] !== values[vi]) isSel = false;
                candidate[i] = values[vi];
                vi++;
              }
            }
          }

          var pv = findVariant(candidate);
          var soldOut = !pv || !pv.available;

          opt.classList.toggle('is-selected', isSel);
          opt.setAttribute('aria-selected', String(isSel));
          opt.classList.toggle('is-soldout', soldOut);

          var priceCell = opt.querySelector('[data-spd-opt-price]');
          if (priceCell) priceCell.textContent = pv ? pv.priceFormatted : '';

          var noteCell = opt.querySelector('[data-spd-opt-note]');
          if (noteCell && !isSize) noteCell.textContent = soldOut ? 'Nicht verfügbar' : '';
          if (noteCell && isSize) noteCell.textContent = soldOut ? 'Nicht verfügbar' : (opt.dataset.note || '');

          if (isSel) {
            if (triggerLabel) triggerLabel.textContent = opt.querySelector('.spd-picker__opt-label').textContent.trim();
            if (triggerNote) triggerNote.textContent = isSize ? (opt.dataset.note || '') : '';
            if (triggerPrice) triggerPrice.textContent = variant.priceFormatted;
            if (triggerChip) {
              var chip = opt.querySelector('.spd-picker__opt-chip');
              triggerChip.hidden = !chip;
              if (chip) triggerChip.style.background = chip.style.background;
            }
          }
        });
      });

      syncGallery(variant);
    }

    // ---- gallery -----------------------------------------------------------
    var plateImg = root.querySelector('[data-spd-plate] img');
    var thumbs = [].slice.call(root.querySelectorAll('[data-spd-thumb]'));
    var countEl = root.querySelector('[data-spd-count]');
    var visible = [];
    var index = 0;

    function show(i) {
      if (!visible.length || !plateImg) return;
      index = (i + visible.length) % visible.length;
      var thumb = visible[index];
      plateImg.removeAttribute('srcset');
      plateImg.src = thumb.dataset.full;
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (countEl) countEl.textContent = (index + 1) + ' / ' + visible.length;
    }

    function syncGallery(variant) {
      var current = visible[index];
      visible = [];
      thumbs.forEach(function (t) {
        var owners = (t.dataset.variantIds || '').trim();
        var universal = owners === '';
        var mine = !universal && owners.split(/\s+/).indexOf(String(variant.id)) !== -1;
        t.hidden = !(universal || mine);
        if (!t.hidden) visible.push(t);
      });

      // Opening the page, and any time the shown image no longer applies,
      // fall back to the first universal image - the artwork. Never yank the
      // view away from an image the visitor deliberately opened.
      var keep = current ? visible.indexOf(current) : -1;
      if (keep === -1) {
        keep = 0;
        for (var i = 0; i < visible.length; i++) {
          if ((visible[i].dataset.variantIds || '').trim() === '') { keep = i; break; }
        }
      }
      show(keep);
      root.classList.toggle('spd-has-gallery', visible.length > 1);
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var i = visible.indexOf(thumb);
        if (i !== -1) show(i);
      });
    });

    var prev = root.querySelector('[data-spd-prev]');
    var next = root.querySelector('[data-spd-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') show(index - 1);
      if (e.key === 'ArrowRight') show(index + 1);
    });

    // ---- option interactions ----------------------------------------------
    function openState(picker, trigger, list, nextOpen) {
      list.hidden = !nextOpen;
      trigger.setAttribute('aria-expanded', String(nextOpen));
      picker.classList.toggle('is-open', nextOpen);
    }

    optionGroups.forEach(function (group) {
      var picker = group.querySelector('[data-spd-picker]');
      var trigger = group.querySelector('[data-spd-trigger]');
      var list = group.querySelector('[data-spd-list]');
      if (!picker || !trigger || !list) return;

      trigger.addEventListener('click', function () {
        openState(picker, trigger, list, list.hidden);
      });
      document.addEventListener('mousedown', function (e) {
        if (!picker.contains(e.target)) openState(picker, trigger, list, false);
      });
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') openState(picker, trigger, list, false);
      });

      group.querySelectorAll('[data-spd-opt]').forEach(function (opt) {
        opt.addEventListener('click', function () {
          if (opt.classList.contains('is-soldout')) return;
          var want = selected.slice();

          if (group.dataset.optionKind === 'size') {
            want[sizeIndex] = opt.dataset.value;
          } else {
            // One row sets every non-size option at once.
            var values = (opt.dataset.combo || '').split('~~');
            var vi = 0;
            for (var i = 0; i < want.length; i++) {
              if (i !== sizeIndex) { want[i] = values[vi]; vi++; }
            }
          }

          var exact = findVariant(want);
          if (!exact) {
            // Keep what was just chosen, relax the rest to something buyable.
            exact = variants.filter(function (v) {
              return group.dataset.optionKind === 'size'
                ? v.options[sizeIndex] === want[sizeIndex] && v.available
                : v.options.every(function (o, i) { return i === sizeIndex || o === want[i]; }) && v.available;
            })[0];
          }
          if (exact) paint(exact);
          openState(picker, trigger, list, false);
        });
      });
    });

    // ---- quantity ----------------------------------------------------------
    var qty = root.querySelector('[data-spd-qty] input');
    var down = root.querySelector('[data-spd-qty-down]');
    var up = root.querySelector('[data-spd-qty-up]');
    if (qty) {
      if (down) down.addEventListener('click', function () {
        qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1);
      });
      if (up) up.addEventListener('click', function () {
        qty.value = (parseInt(qty.value, 10) || 1) + 1;
      });
    }

    paint(start);
  }

  function boot() { document.querySelectorAll('.spd-product').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
